import React from 'react'
import { NewFooter } from 'components/Layout/Footer/NewFooter'
import { EntityDetailLayout } from 'components/EntityDetailPage/EntityDetailLayout'
import { CompanySidebarNew } from './Sidebar/CompanySidebarNew'
import type { CompanySidebarHeader, SidebarTabConfig } from './Sidebar'
import { useHideFooter, useDynamicCategoryInfo } from 'context/layout'
import type { BreadcrumbItem } from 'components/Layout/Header/types'

interface CompanyPageLayoutNewProps {
  chainProxyId: number
  sidebar: {
    header: CompanySidebarHeader
    tabs: SidebarTabConfig[]
  }
  doorId?: number
  address?: string
  phone?: string
  children?: React.ReactNode
  /** Entity breadcrumbs for new navigation header */
  entityBreadcrumbs?: BreadcrumbItem[]
  /** Dynamic category info for unmatched/user-generated pages */
  categoryInfo?: {
    categorySlug: string
    subCategorySlug: string
  }
}

/**
 * Company page layout with sidebar, footer, and entity breadcrumbs.
 *
 * Wraps EntityDetailLayout with company-specific sidebar, footer placement,
 * and dynamic category info support.
 */
export function CompanyPageLayoutNew(props: CompanyPageLayoutNewProps) {
  const { chainProxyId, entityBreadcrumbs, categoryInfo } = props

  // Hide global layout footer — company pages render their own inside the scroll area
  useHideFooter()

  // Set dynamic category info for unmatched/user-generated pages
  useDynamicCategoryInfo(
    categoryInfo?.categorySlug,
    categoryInfo?.subCategorySlug
  )

  return (
    <EntityDetailLayout
      gap={6}
      contentGap={6}
      className="gap-y-4"
      contentClassName="pb-0"
      entityBreadcrumbs={entityBreadcrumbs}
      sidebar={
        <CompanySidebarNew
          chainProxyId={chainProxyId}
          {...props.sidebar}
          doorId={props.doorId}
          address={props.address}
          phone={props.phone}
        />
      }
    >
      {props.children}
      <div className="mt-auto">
        <NewFooter />
      </div>
    </EntityDetailLayout>
  )
}
